export default "__VITE_ASSET__Bh41__sK__"